export function isVisualModelSerializationV2(what) {
    return what.type === "http://dataspecer.com/resources/local/visual-model"
        && what.version === 2;
}
//# sourceMappingURL=serialization-v2.js.map